import browserHistory from '../utils/browserHistory';
import CustomNotify from '../components/Notify';
import runtimeConfig from '../config/runtimeConfig';
import UserStore from '../stores/UserStore';

// one notification for the same error of the parallel requests of a page (table, chart, dictionaries)
const TOAST_ID = 'request-error';

const translate = (key, fallback) => {
    const translations = UserStore.getTranslation() || {};

    return (translations.notyMessages && translations.notyMessages[key]) || fallback;
};

const notify = (message) => {
    CustomNotify(message, 'error', {toastId: `${TOAST_ID}:${message}`});
};

/**
 * Handles a rejected API request (api/index.js, makeRequest).
 * - API errors ({error: {code, message}}, HTTP 200 / 400): the message is shown, then callback;
 *   without callback - the 500 page (as before).
 * - HTTP errors (5xx etc., err.error.httpError): the message of the server or a common one, then callback;
 *   without callback only the notification (a failed background request does not leave the page).
 * - Network and unexpected errors (no err.error): a common notification, then callback; 401 / 403 are only logged
 *   (the authorisation is handled by makeRequest / SessionActions).
 * The callback usually dispatches the *_FAIL action, which ends the loading of the page.
 */
const handleError = (err, callback) => {
    if (err && err.error) {
        const message = err.error.message || '';

        if (err.error.httpError) {
            notify(message && message !== 'Bad Request'
                ? message
                : translate('serverError', 'The server returned an error. Please try again later.'));
            callback && callback();

            return;
        }

        if (callback) {
            if (message && message !== 'Bad Request') {
                notify(message);
            }

            callback();
        } else {
            browserHistory.push(`${runtimeConfig.defaultRoute}500`);
        }

        return;
    }

    console.error(err);

    if (err && (err.status === 401 || err.status === 403)) {
        return;
    }

    notify(translate('networkError', 'The server is not responding. Please try again later.'));
    callback && callback();
};

export default handleError;
